import type { FiltrosDeChamado } from '../../../api/filtrosDeChamado'
import { cn } from '../../../lib/cn'
import { TRIAGENS, triagemAtiva } from './triagem'

interface Props {
  filtros: FiltrosDeChamado
  alterar: (mudanca: Partial<FiltrosDeChamado>) => void
}

/**
 * Os atalhos de triagem, em fileira, acima da lista.
 *
 * Existem porque quatro perguntas respondem por quase todo acesso à tela — o que está no prazo, o
 * que estourou, o que está fora da medição e o que é projeto — e abrir um painel, marcar uma caixa
 * e clicar em "Aplicar" para cada uma delas é o tipo de trabalho que faz o usuário parar de filtrar
 * e passar a rolar a lista inteira.
 *
 * São botões com `aria-pressed`, e não abas nem grupo de rádio: aba anuncia que troca de painel
 * (aqui o conteúdo é o mesmo, recortado) e rádio exige navegação por setas, que quem chega pelo Tab
 * não espera numa fileira de filtros.
 *
 * @param props critérios correntes e a função que os altera
 * @returns a fileira de atalhos
 */
export function ChipsDeTriagem({ filtros, alterar }: Props) {
  const ativa = triagemAtiva(filtros)

  return (
    // A rolagem lateral é da fileira, não da página: em tela estreita os atalhos não cabem, e
    // quebrá-los em três linhas empurraria a lista para baixo da dobra.
    <div role="group" aria-label="Atalhos para filtrar a lista" className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
      {TRIAGENS.map((triagem) => {
        const selecionada = triagem.id === ativa
        return (
          <button
            key={triagem.id}
            type="button"
            title={triagem.ajuda}
            aria-pressed={selecionada}
            onClick={() => alterar(triagem.recorte)}
            className={cn(
              'whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors',
              'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
              'focus-visible:outline-niteroi-600',
              selecionada
                ? 'bg-niteroi-700 text-white shadow-sm hover:bg-niteroi-800'
                : 'bg-white text-slate-700 ring-1 ring-inset ring-slate-300 hover:bg-niteroi-50 hover:text-niteroi-800',
            )}
          >
            {triagem.rotulo}
          </button>
        )
      })}
    </div>
  )
}
